import { ITaskTemplateDetailViewUtil } from "Interfaces/Utils/ITaskTemplateDetailViewUtil";
import { injectable } from "inversify";
import cloneDeep from "lodash/cloneDeep";
import { TaskTemplate } from "Models/Tasks/TaskTemplate";
import i18n from "Translations/i18n";

@injectable()
export class TaskTemplateDetailViewUtil implements ITaskTemplateDetailViewUtil {

    public duplicateTaskTemplate(taskTemplateToDuplicate: TaskTemplate): TaskTemplate {
        const duplicatedFromTaskTemplateId = taskTemplateToDuplicate.id;
        const duplicatedTaskTemplate = cloneDeep(taskTemplateToDuplicate);

        duplicatedTaskTemplate.id = undefined;
        duplicatedTaskTemplate.name = `${i18n.t("common.copyOf")} ${taskTemplateToDuplicate.name}`;
        duplicatedTaskTemplate.duplicatedFromTaskTemplateId = duplicatedFromTaskTemplateId;
        for (let i = 0; i < duplicatedTaskTemplate.steps.length; ++i) {
            const step = duplicatedTaskTemplate.steps[i];
            step.duplicatedFromTaskTemplateStepId = step.id;
            step.id = (-i - 1);
        }
        if (duplicatedTaskTemplate.taskRecurrencies.length) {
            duplicatedTaskTemplate.taskRecurrencies[0].id = undefined;
            if (duplicatedTaskTemplate.taskRecurrencies[0].taskOneTimeRecurrencies && duplicatedTaskTemplate.taskRecurrencies[0].taskOneTimeRecurrencies.length) {
                duplicatedTaskTemplate.taskRecurrencies[0].taskOneTimeRecurrencies[0].id = undefined;
            }
            if (duplicatedTaskTemplate.taskRecurrencies[0].taskShiftRecurrencies && duplicatedTaskTemplate.taskRecurrencies[0].taskShiftRecurrencies.length) {
                duplicatedTaskTemplate.taskRecurrencies[0].taskShiftRecurrencies[0].id = undefined;
            }
        }

        return duplicatedTaskTemplate;
    }
}


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateDetailView/Utils/TaskTemplateDetailViewUtil.ts